import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { PhoneInput } from '@cw-ui/phone-input';

// PhoneInput renders input and helper in separate wrappers (Fragment). Wrap in a
// single Box so grid layouts treat the field as one cell, not two siblings.
const PHONE_FIELD_SX = {
  '& .MuiFormHelperText-root': {
    marginTop: theme => theme.spacing(0.5)
  }
};

const PhoneField = ({ field, value, onChange, onBlur, helperText, errorText, disabled = false }) => {
  const hasError = Boolean(errorText);

  // mui-tel-input reports a value like "+98" (just the dial code, no digits)
  // when the user only changes the country - it's still an empty phone
  // number from the user's perspective. Treat it as empty so required/format
  // validation doesn't fire until the user actually types a number.
  const handleChange = (newValue, info) => onChange(info?.nationalNumber ? newValue : '');

  return (
    <Box sx={PHONE_FIELD_SX}>
      <PhoneInput
        id={field.id}
        label={field.label}
        required={field.required}
        placeholder={field.placeholder}
        defaultCountry={field.defaultCountryCode || 'US'}
        value={value ?? ''}
        onChange={handleChange}
        onBlur={onBlur}
        error={hasError}
        helperText={errorText ?? helperText}
        disabled={disabled}
      />
    </Box>
  );
};

PhoneField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    defaultCountryCode: PropTypes.string
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  helperText: PropTypes.string,
  errorText: PropTypes.string,
  disabled: PropTypes.bool
};

export default PhoneField;
